import React, { ChangeEvent, useState } from 'react';

import { Wrapper, Title, InputTextArea, Line, Bottom, Actions, Cancel } from './textAreaModal.style';
import { getLoadData, updateDriverInstructions, updateInternalNotes } from '../../../../API/loads';
import Button from '../../../../components/Button/Button';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import ModalPortal from '../../ModalPortal';

type ModalAssignProps = {
  close: () => void;
  title: string;
  refTextAreaModal: any;
};

const TextAreaModal: React.FC<ModalAssignProps> = ({ close, title, refTextAreaModal }) => {
  const { loadId, loadInfo } = useAppSelector((state: { loads: any }) => state.loads);

  const dispatch = useAppDispatch();

  const [value, setValue] = useState<string>(
    title === 'Driver Instruction'
      ? loadInfo?.load?.driver_instructions
        ? loadInfo?.load?.driver_instructions
        : ''
      : loadInfo?.load?.internal_notes
        ? loadInfo?.load?.internal_notes
        : ''
  );

  const handleConfirm = async () => {
    if (title === 'Driver Instruction') {
      await dispatch(updateDriverInstructions([loadId.id, value]));
    } else {
      await dispatch(updateInternalNotes([loadId.id, value]));
    }

    await dispatch(getLoadData(loadId.id));
    close();
  };

  return (
    <ModalPortal>
      <Wrapper ref={refTextAreaModal}>
        <Title>{title}</Title>
        <Line />

        <InputTextArea
          rows={8}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setValue(e.target.value)}
          value={value}
        />

        <Line />
        <Bottom>
          <Actions>
            <Cancel onClick={close}>Cancel</Cancel>
            <Button text="Save" pad="12px 26px" handleButton={handleConfirm} />
          </Actions>
        </Bottom>
      </Wrapper>
    </ModalPortal>
  );
};

export default TextAreaModal;
